"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  var overlap = arguments.length <= 0 || arguments[0] === undefined ? 0 : arguments[0];
  return function (_ref) {
    var length = _ref.length;
    return 1 - (1 + overlap) / length;
  };
};